import { render, staticRenderFns } from "./CouponForm.vue?vue&type=template&id=5e460405&scoped=true"
import script from "./CouponForm.vue?vue&type=script&lang=js"
export * from "./CouponForm.vue?vue&type=script&lang=js"
import style0 from "./CouponForm.vue?vue&type=style&index=0&id=5e460405&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e460405",
  null
  
)

export default component.exports